/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_8Inputs */

const en_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop & Web Application access`)
};

const fr_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès aux applications de bureau et Web`)
};

const de_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff auf Desktop- und Webanwendungen`)
};

const it_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso alle applicazioni desktop e web`)
};

const ru_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ к настольным и веб-приложениям.`)
};

const es_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso a aplicaciones web y de escritorio`)
};

const zh_cn2_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌面和 Web 应用程序访问`)
};

const ja_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デスクトップおよびWebアプリケーションへのアクセス`)
};

const hi_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेस्कटॉप और वेब एप्लिकेशन तक पहुंच`)
};

const pt_pt2_signup_feature_starter_8 = /** @type {(inputs: Signup_Feature_Starter_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso a aplicativos de desktop e web`)
};

/**
* | output |
* | --- |
* | "Desktop & Web Application access" |
*
* @param {Signup_Feature_Starter_8Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_8 = /** @type {((inputs?: Signup_Feature_Starter_8Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_8Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_starter_8(inputs)
	if (locale === "de") return de_signup_feature_starter_8(inputs)
	if (locale === "it") return it_signup_feature_starter_8(inputs)
	if (locale === "ru") return ru_signup_feature_starter_8(inputs)
	if (locale === "es") return es_signup_feature_starter_8(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_starter_8(inputs)
	if (locale === "ja") return ja_signup_feature_starter_8(inputs)
	if (locale === "hi") return hi_signup_feature_starter_8(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_starter_8(inputs)
	return en_signup_feature_starter_8(inputs)
});